<template>
  <form @submit.prevent="submit" class="form" method="post">
    <FormInput :name="$t('orderTemplates.name')" v-model="orderTemplate.name" required />

    <FormSimpleSelect
      :name="$t('orderTemplates.orderType')"
      :options="supportedOrderTypeOptions()"
      v-model="orderTemplate.order_type"
    />

    <SiteSelect
      v-model="orderTemplate.site_uuid"
      :companyUuid="companyUser.company_uuid"
      required
      @input="fordceRerender"
    />

    <div class="form-wrap">
      <label>{{ $t('orderTemplates.weekdays') }}</label>
      <FormMultiCheckboxes :items="weekdayOptions" v-model="orderTemplate.weekdays" :twoColumned="false" gap="1.5rem" />
    </div>

    <VehicleSelect
      v-model="orderTemplate.vehicle_uuid"
      :companyUuid="companyUser.company_uuid"
      required
      @input="fordceRerender"
    />

    <div class="form-wrap">
      <label>{{ $t('orderTemplates.pause') }}</label>
      <FormSingleCheckbox v-model="orderTemplate.paused" label="" name="paused" />
    </div>

    <div class="form-wrap" v-show="orderTemplate.paused">
      <label>{{ $t('orderTemplates.continueOn') }}</label>

      <input
        type="date"
        :min="tomorrow()"
        v-show="orderTemplate.paused"
        v-model="orderTemplate.continue_on"
        class="form-input"
      />
    </div>

    <div>
      <input type="submit" :value="$t('meta.save')" :disabled="!valid" class="button button-green button-100" />
    </div>
  </form>
</template>

<script>
import moment from 'moment'

import FormMultiCheckboxes from '@/components/Form/Checkbox/MultiCheckboxes'
import FormSingleCheckbox from '@/components/Form/Checkbox/SingleCheckbox'
import FormInput from '@/components/Form/Input'
import FormSimpleSelect from '@/components/Form/SimpleSelect'
import SiteSelect from '@/components/Orders/forms/sections/elements/SiteSelect.vue'
import VehicleSelect from '@/components/Orders/forms/sections/elements/VehicleSelect.vue'

export default {
  inject: ['companyUser'],
  props: {
    companyUuid: String,
    existingOrderTemplate: Object,
  },
  components: {
    FormInput,
    FormSimpleSelect,
    SiteSelect,
    FormMultiCheckboxes,
    FormSingleCheckbox,
    VehicleSelect,
  },
  data: function () {
    return {
      orderTemplate: this.existingOrderTemplate || {
        name: null,
        order_type: 'GatheringOrder',
        site_uuid: null,
        weekdays: [],
        vehicle_uuid: null,
      },
      supportedOrderTypes: ['GatheringOrder'],
    }
  },
  methods: {
    submit() {
      this.$emit('submit', this.orderTemplate)
    },
    supportedOrderTypeOptions() {
      const self = this

      return this.supportedOrderTypes.map(function (orderType) {
        const name = orderType.slice(0, -5).toLowerCase() // Cut off "Order" from "GatheringOrder" and downcase
        return { name: self.$t('meta.orderTypes')[name], uuid: orderType }
      })
    },
    fordceRerender() {
      // Somehow the SiteSelect/VehicleSelect (or FormSelect) component doesn't render
      // a change until something else in the form changes. So let's manually force an
      // update when the SiteSelect/VehicleSelect receives an input event.
      this.$forceUpdate()
    },
    tomorrow() {
      return moment().add(1, 'day').format('YYYY-MM-DD')
    },
  },
  computed: {
    weekdayOptions() {
      const self = this
      const weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']

      return weekdays.map(function (weekday) {
        return { label: self.$t(`meta.${weekday}`), value: weekday }
      })
    },
    valid() {
      if (this.orderTemplate.name === null) return false
      if (/^\s*$/.test(this.orderTemplate.name)) return false

      if (this.orderTemplate.site_uuid === null) return false
      if (this.orderTemplate.site_uuid === undefined) return false // it becomes undefined when pressing the x (resetting)
      if (/^\s*$/.test(this.orderTemplate.site_uuid)) return false

      if (this.orderTemplate.weekdays.length === 0) return false
      if (this.orderTemplate.vehicle_uuid === null) return false
      // interestingly, this doesn't become undefined when pressing the x, it becomes null:
      // if (this.orderTemplate.vehicle_uuid === undefined) return false

      return true
    },
  },
}
</script>
